import { agentsConstants, agentsLookupConstants } from '@constants/agents';
import { agentsService } from '@services';

function request() {
    return { type: agentsConstants.AGENTS_FETCH };
}

function success(data) {
    return { type: agentsConstants.AGENTS_SUCCESS, data };
}

function failure() {
    return { type: agentsConstants.AGENTS_ERROR };
}

const get = () => {
    return dispatch => {
        dispatch(request());
        agentsService.get().then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

const getLookup = () => {
    return dispatch => {
        dispatch({ type: agentsLookupConstants.AGENTS_LOOKUP_FETCH });
        agentsService.getLookup().then(
            data => dispatch({ type: agentsLookupConstants.AGENTS_LOOKUP_SUCCESS, data }),
            () => dispatch({ type: agentsLookupConstants.AGENTS_LOOKUP_ERROR }),
        );
    };
};

function update(data) {
    return { type: agentsConstants.AGENTS_UPDATE, data };
}

export const agentsActions = {
    get,
    getLookup,
    update,
};
